// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "utf-8";
/* CSS Document */

.wrapper {
 text-transform: uppercase;
 color: #555;
 cursor: help;
 font-size: 22px;
 position: relative;
 text-align: center;
 -webkit-transform: translateZ(0); /* webkit flicker fix */
 -webkit-font-smoothing: antialiased; /* webkit text rendering fix */
}

.wrapper .tooltip {
 background: #ce104e;
 bottom: 68%;
 color: #fff;
 display: block;
 left: -10px;

 margin-bottom: 15px;
 opacity: 0;
 padding: 3px;
 pointer-events: none;
 position: absolute;
 border-radius: 3px;
 transform: translateY(10px);
 transition: all .25s ease-out;
 -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
  -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
     box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
}

/* This bridges the gap so you can mouse into the tooltip without it disappearing */
.wrapper .tooltip:before {
 bottom: -20px;
 content: " ";
 display: block;
 height: 20px;
 left: 0;
 position: absolute;
 width: 100%;
}  

/* CSS Triangles - see Trevor's post */
.wrapper .tooltip:after {
 border-left: solid transparent 10px;
 border-right: solid transparent 10px;
 border-top: solid #ce104e 10px;
 bottom: -10px;
 content: " ";
 height: 0;
 left: 50%;
 margin-left: -13px;
 position: absolute;
 width: 0;
}
 
.wrapper:hover .tooltip {
 opacity: 1;
 pointer-events: auto;
 transform: translateY(0px);
}

/* IE can just show/hide with no transition */
.lte8 .wrapper .tooltip {
 display: none;
}

.lte8 .wrapper:hover .tooltip {
 display: block;
}


.spce {
   
    margin-left: 6px;
  
}
.spces {
margin-left:30px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/tooltip.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,iBAAiB;;AAEjB;CACC,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,gCAAgC,EAAE,uBAAuB;CACzD,mCAAmC,EAAE,8BAA8B;AACpE;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,WAAW;CACX,cAAc;CACd,WAAW;;CAEX,mBAAmB;CACnB,UAAU;CACV,YAAY;CACZ,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;CAKV,2BAA2B;CAK3B,6BAA6B;CAGjC,+CAA+C;EAC9C,8CAA8C;KAC3C,2CAA2C;AACpD;;AAEA,mFAAmF;AACnF;CACC,aAAa;CACb,YAAY;CACZ,cAAc;CACd,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,WAAW;AACZ;;AAEA,sCAAsC;AACtC;CACC,mCAAmC;CACnC,oCAAoC;CACpC,8BAA8B;CAC9B,aAAa;CACb,YAAY;CACZ,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,UAAU;CACV,oBAAoB;CAKZ,0BAA0B;AACnC;;AAEA,6CAA6C;AAC7C;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;;AAGA;;IAEI,gBAAgB;;AAEpB;AACA;AACA,gBAAgB;AAChB","sourcesContent":["@charset \"utf-8\";\r\n/* CSS Document */\r\n\r\n.wrapper {\r\n text-transform: uppercase;\r\n color: #555;\r\n cursor: help;\r\n font-size: 22px;\r\n position: relative;\r\n text-align: center;\r\n -webkit-transform: translateZ(0); /* webkit flicker fix */\r\n -webkit-font-smoothing: antialiased; /* webkit text rendering fix */\r\n}\r\n\r\n.wrapper .tooltip {\r\n background: #ce104e;\r\n bottom: 68%;\r\n color: #fff;\r\n display: block;\r\n left: -10px;\r\n\r\n margin-bottom: 15px;\r\n opacity: 0;\r\n padding: 3px;\r\n pointer-events: none;\r\n position: absolute;\r\n border-radius: 3px;\r\n -webkit-transform: translateY(10px);\r\n    -moz-transform: translateY(10px);\r\n     -ms-transform: translateY(10px);\r\n      -o-transform: translateY(10px);\r\n         transform: translateY(10px);\r\n -webkit-transition: all .25s ease-out;\r\n    -moz-transition: all .25s ease-out;\r\n     -ms-transition: all .25s ease-out;\r\n      -o-transition: all .25s ease-out;\r\n         transition: all .25s ease-out;\r\n -webkit-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\r\n    -moz-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\r\n     -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\r\n      -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\r\n         box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);\r\n}\r\n\r\n/* This bridges the gap so you can mouse into the tooltip without it disappearing */\r\n.wrapper .tooltip:before {\r\n bottom: -20px;\r\n content: \" \";\r\n display: block;\r\n height: 20px;\r\n left: 0;\r\n position: absolute;\r\n width: 100%;\r\n}  \r\n\r\n/* CSS Triangles - see Trevor's post */\r\n.wrapper .tooltip:after {\r\n border-left: solid transparent 10px;\r\n border-right: solid transparent 10px;\r\n border-top: solid #ce104e 10px;\r\n bottom: -10px;\r\n content: \" \";\r\n height: 0;\r\n left: 50%;\r\n margin-left: -13px;\r\n position: absolute;\r\n width: 0;\r\n}\r\n \r\n.wrapper:hover .tooltip {\r\n opacity: 1;\r\n pointer-events: auto;\r\n -webkit-transform: translateY(0px);\r\n    -moz-transform: translateY(0px);\r\n     -ms-transform: translateY(0px);\r\n      -o-transform: translateY(0px);\r\n         transform: translateY(0px);\r\n}\r\n\r\n/* IE can just show/hide with no transition */\r\n.lte8 .wrapper .tooltip {\r\n display: none;\r\n}\r\n\r\n.lte8 .wrapper:hover .tooltip {\r\n display: block;\r\n}\r\n\r\n\r\n.spce {\r\n   \r\n    margin-left: 6px;\r\n  \r\n}\r\n.spces {\r\nmargin-left:30px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
